import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "File *", -1)
const _hoisted_5 = { class: "field col-1" }
const _hoisted_6 = { for: "startDate" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "field col-1" }
const _hoisted_10 = { for: "endDate" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "field col-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)

import Button from 'primevue/button'
import Panel from 'primevue/panel'
import Calendar from "primevue/calendar";
import FileUpload, {FileUploadBeforeUploadEvent, FileUploadSelectEvent} from "primevue/fileupload";

import {AxiosStatic} from "axios";
import {inject, reactive, ref} from "vue";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import InputField from "@/components/blocks/InputField.vue";
import moment from "moment";
import CompanyField from "@/components/blocks/CompanyField.vue";

// Define types
type FormData = {
  company: any | null,
  note: string | null,
  orderNumber: string | null,
  startDate: string | null,
  endDate: string | null

}

// Define component data

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateRequisitionForm',
  emits: ['itemCreated'],
  setup(__props, { emit: emits }) {

const formData = reactive<FormData>({
  company: null,
  note: null,
  orderNumber: null,
  startDate: null,
  endDate: null,

})

const formRef = ref(null)
const submitted = ref<boolean>(false)
let fileName: (string | null) = null

const rules = {
  company: {required},
  note: {required},
  orderNumber: {required},
  startDate: {required},
  endDate: {required},
}

// Define emits


// Inject dependencies
const axios = inject<AxiosStatic>('axios')

// Define used properties
const router = useRouter()
const v$ = useVuelidate(rules, formData)
const fileUpload = ref<FileUpload>()

// Define functions
function beforeUploadHandler(event: FileUploadBeforeUploadEvent) {
  event.formData.set("note", formData.note)
  event.formData.set("orderNumber", formData.orderNumber)
  event.formData.set("startDate", moment(formData.startDate).format("YYYY-MM-DD"))
  event.formData.set("endDate", moment(formData.endDate).format("YYYY-MM-DD"))
  event.formData.set("companyId", formData.company.id)

  if (fileName != null) {
    event.formData.set("fileName", fileName)
  }

}

function fileSelected(event: FileUploadSelectEvent) {
  if (event.files.length > 0) {
    fileName = event.files[0].name
  } else {
    fileName = null
  }
}

function uploadDone() {
  emits('itemCreated', {})
}

function handleSubmit(isFormValid: boolean) {
  submitted.value = true
  if (isFormValid) {
    fileUpload.value.upload()
    // saveRequisition()
  } else {
    console.error('Form is not valid!')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Panel), {
    header: "Create Requisition",
    toggleable: true,
    collapsed: true,
    class: "mt-2 mb-2"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
        class: "p-fluid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(CompanyField, {
              id: "company",
              class: "col-2`",
              label: "Company",
              modelValue: formData.company,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.company) = $event)),
              vualidate: _unref(v$).company,
              submitted: submitted.value
            }, null, 8, ["modelValue", "vualidate", "submitted"]),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(FileUpload), {
                name: "file",
                ref_key: "fileUpload",
                ref: fileUpload,
                mode: "basic",
                class: "p-button-lg",
                showUploadButton: false,
                showCancelButton: false,
                multiple: false,
                url: "/requisition/create",
                onUpload: uploadDone,
                onSelect: fileSelected,
                onBeforeUpload: beforeUploadHandler
              }, null, 512)
            ]),
            _createVNode(InputField, {
              id: "orderNumber",
              class: "col-1",
              label: "Order number",
              vualidate: _unref(v$).orderNumber,
              submitted: submitted.value,
              modelValue: formData.orderNumber,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.orderNumber) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _createTextVNode("Start date "),
                (_unref(v$).startDate.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "startDate",
                dateFormat: "yy-mm-dd",
                class: _normalizeClass({'p-invalid':_unref(v$).startDate.$invalid && submitted.value}),
                modelValue: _unref(v$).startDate.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).startDate.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).startDate.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_unref(v$).startDate.required.$message.replace('Value', 'Start date')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createTextVNode("End date "),
                (_unref(v$).endDate.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(Calendar), {
                id: "endDate",
                dateFormat: "yy-mm-dd",
                class: _normalizeClass({'p-invalid':_unref(v$).endDate.$invalid && submitted.value}),
                modelValue: _unref(v$).endDate.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).endDate.$model) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_unref(v$).endDate.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_unref(v$).endDate.required.$message.replace('Value', 'End date')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(InputField, {
              id: "note",
              class: "col-5",
              label: "Note",
              vualidate: _unref(v$).note,
              submitted: submitted.value,
              modelValue: formData.note,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.note) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_unref(Button), {
                type: "submit",
                label: "Pridat",
                class: "p-button-lg"
              })
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})